import React, { Component } from "react";
import PropTypes from 'prop-types';

import './style.scss';
import { withSelect, withDispatch } from "@wordpress/data";

class Header extends Component {
	componentDidMount() {
		if ( location.hash !== '' && location.hash !== '#' && location.hash.length > 1 ) {
			const { active, activeSubTabs, updateTab, updateSubTab } = this.props;
			const hashItems = location.hash.replace('#', '').split( '/' );
			if ( hashItems.length > 1 ) {
				let parentIndex = 0;
				kitOptions.map( ( tab, i ) => {
					if ( hashItems[0] === tab.id ) {
						parentIndex = i;
					}
				} );
				if ( kitOptions[parentIndex] && kitOptions[parentIndex].tabs ) {
					kitOptions[parentIndex].tabs.map( ( tab, i ) => {
						if ( hashItems[1] === tab.id ) {
							updateSubTab( i, kitOptions[parentIndex].id );
						}
					} )
				}
			} else if ( hashItems.length === 1 ) {
				kitOptions.map( ( tab, i ) => {
					if ( hashItems[0] === tab.id ) {
						updateTab( i );
					}
				} );
			}
		}
	}
	renderItem( tab, index, sub = false ) {
		const { active, activeSubTabs, updateTab, updateSubTab } = this.props;
		const activeTab = kitOptions !== undefined && kitOptions[active] !== undefined ? kitOptions[active] : undefined;
		const activeSubTab = activeSubTabs[activeTab.id] || 0;
		const isActive = sub ? activeSubTab === index : active === index;

		const hasChild = tab.tabs !== undefined;
		return (
			<li className={ `${ isActive ? 'is-active' : '' } ${ hasChild ? 'has-child' : '' }` } key={tab.id}>
				<a href={`#${tab.id}`} onClick={ ( e ) => {
					e.preventDefault();

					
					if ( sub ) {
						location.hash = `${activeTab.id}/${tab.id}`;
						updateSubTab( index, activeTab.id );
					} else {
						location.hash = tab.id;
						updateTab( index );
					}
				} }>{tab.title}</a>
			</li>
		)
	}
	render() {
		const { active } = this.props;
		const activeTab = kitOptions !== undefined && kitOptions[active] !== undefined ? kitOptions[active] : undefined;
		return(
			<>
				<div className="options-kit-header-inner">
					<div className="plugin-name">
						<span className="options-kit-title">{ kitInfo && kitInfo.title }</span>
						<span className="options-kit-version">v{ kitInfo && kitInfo.version }</span>
					</div>
					<nav className="options-kit-main-nav">
						<ul>
							{
								kitOptions && kitOptions.map( ( tab, i ) => this.renderItem( tab, i ) )
							}
						</ul>
						{
							kitInfo && kitInfo.links &&
							<ul>
								{
									kitInfo.links.map( ( link, i ) => (
										<li key={ i }>
											<a href={ link.link } target="_blank">{ link.title }</a>
										</li>
									) )
								}
							</ul>
						}
					</nav>
				</div>
				{
					activeTab && activeTab.tabs &&
					<div className="options-kit-sub-nav">
						<ul>
							{
								activeTab.tabs.map( ( tab, i ) => this.renderItem( tab, i, true ) )
							}
						</ul>
					</div>
				}
			</>
		);
	}
}

Header.propTypes = {
	active: PropTypes.number,
	activeSubTabs: PropTypes.object,
	updateTab: PropTypes.func,
	updateSubTab: PropTypes.func,
};

export default withDispatch( ( dispatch ) => {
	const { activeTab, activeSubTab } = dispatch( 'options-kit' );
	return {
		updateTab: activeTab,
		updateSubTab: activeSubTab,
	};
} )( withSelect( ( select ) => {
	return {
		active: select( 'options-kit' ).getActiveTab(),
		activeSubTabs: select( 'options-kit' ).getActiveSubTabs(),
	}
} )( Header ) );
